import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Tabs, Button, Modal } from "antd";
import { OrderedListOutlined, UnorderedListOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { SugestoesSorteiosItens } from "./components/sorteiosItens";
import { SugestoesSorteiosDetalhes } from "./components/sorteioDetalhes";
import http from "../../../services/http";
const { Text } = Typography;

export const SugestoesSorteiosItensCadastro = () => {
  const { id_sorteio } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sorteando, setSorteando] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // PRODUTO
  const [sorteio, setSorteio] = useState(null);

  useEffect(() => {
    if (id_sorteio) {
      carregarSorteio(id_sorteio);
    }
  }, [id_sorteio]);

  // CARREGAR SORTEIO
  const carregarSorteio = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/sugestoes_sorteios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setSorteio(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/sugestoes/sorteios");
    }
    setLoading(false);
  };

  // REALIZAR SORTEIO
  const realizarSorteio = async (id) => {
    if (!id) return;
    setLoading(true);
    setSorteando(true);
    const api = await http("post", `v1/sugestoes_sorteios/realizar_sorteio`, {
      id_sorteio: id,
    });
    if (api.statusCode === 200) {
      carregarSorteio(id);
    } else {
      message.error(api.response.message);
      navigate("/sugestoes/sorteios");
    }
    setTimeout(() => {
      setSorteando(false);
    }, "4000");
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: `Itens`,
      children: <SugestoesSorteiosItens idSorteio={id_sorteio} dadosSorteio={sorteio} />,
    },
    {
      key: "2",
      label: `Detalhes`,
      children: <SugestoesSorteiosDetalhes idSorteio={id_sorteio} dadosSorteio={sorteio} />,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/sugestoes/sorteios")} />
            <HeaderTitle
              title="Sorteios Itens"
              subtitle={
                <Text italic>
                  <UnorderedListOutlined /> {sorteio?.descricao ?? ""}
                </Text>
              }
              icon={<OrderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              {sorteando ? (
                <div className="content-card-image">
                  <img src="https://statics.coperdia.com.br/portal_colaborador/img/ticket.gif" />{" "}
                </div>
              ) : (
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  tabBarExtraContent={{
                    right: sorteio?.status === 0 && (
                      <Button
                        icon={<CheckCircleOutlined />}
                        onClick={() => {
                          modal.confirm({
                            title: "Deseja realizar o sorteio?",
                            okText: "Sim",
                            cancelText: "Cancelar",
                            onOk() {
                              realizarSorteio(id_sorteio);
                            },
                          });
                        }}>
                        Sortear
                      </Button>
                    ),
                  }}
                />
              )}
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
